document.addEventListener("DOMContentLoaded", function () {
  const container = document.querySelector(".custom-testimonial-slider");
  const slider = container.querySelector(".testimonial-slides");
  const slidesToShow = parseInt(container.dataset.slidesToShow, 10) || 1;
  const autoPlay = container.dataset.autoPlay === "true" || false;

  const containerWidth = container.offsetWidth;
  const slideWidth = containerWidth / slidesToShow;
  const slides = slider.querySelectorAll(".testimonial-slide");

  slides.forEach((slide) => {
    slide.style.flex = `0 0 ${slideWidth}px`;
  });

  const totalWidth = slideWidth * slides.length;
  slider.style.width = `${totalWidth}px`;

  const pixelsPerSecond = 50;
  const duration = totalWidth / pixelsPerSecond;

  if (autoPlay) {
    slider.style.animation = `slide-left linear ${duration}s infinite`;
  }

  let isDragging = false;
  let startX = 0;
  let scrollStart = 0;
  let lastX = 0;
  let velocity = 0;
  let raf;

  function pauseAnimation() {
    slider.style.animationPlayState = "paused";
  }

  function resumeAnimation() {
    slider.style.animationPlayState = "running";
  }

  function easeOutInertia() {
    if (Math.abs(velocity) < 0.1) return;
    container.scrollLeft += velocity;
    velocity *= 0.95; // friction
    raf = requestAnimationFrame(easeOutInertia);
  }

  function stopInertia() {
    cancelAnimationFrame(raf);
  }

  function handleDown(pageX) {
    isDragging = true;
    pauseAnimation();
    container.classList.add("grabbing");
    startX = pageX - container.offsetLeft;
    scrollStart = container.scrollLeft;
    stopInertia();
  }

  function handleMove(pageX) {
    if (!isDragging) return;
    const x = pageX - container.offsetLeft;
    const walk = x - startX;
    velocity = x - lastX;
    container.scrollLeft = scrollStart - walk;
    lastX = x;
  }

  function handleUp() {
    isDragging = false;
    container.classList.remove("grabbing");
    easeOutInertia();
    resumeAnimation();
  }

  // 🖱️ Mouse Events
  container.addEventListener("mousedown", (e) => {
    handleDown(e.pageX);
  });

  container.addEventListener("mousemove", (e) => {
    handleMove(e.pageX);
  });

  container.addEventListener("mouseup", handleUp);
  container.addEventListener("mouseleave", () => {
    if (isDragging) handleUp();
  });

  // 📱 Touch Events
  container.addEventListener("touchstart", (e) => {
    handleDown(e.touches[0].pageX);
  });

  container.addEventListener("touchmove", (e) => {
    handleMove(e.touches[0].pageX);
  });

  container.addEventListener("touchend", handleUp);
});
